import HeroImg1 from '../Projects/P1/1.jpg';
import HeroImg2 from '../Projects/P1/2.jpg';
import HeroImg from '../images/HeroImage.jpg';
import HeroImg3 from '../images/HeroImage1.jpg';
import HeroImg4 from '../Projects/P1/3.jpg';
import HeroImg5 from '../Projects/P1/4.jpg';
import HeroImg6 from '../Projects/P1/5.jpg';

export const Bio = {
  name: "Ayoub Oihi",
  roles: [
    "Geomatics Engineer",
    "Remote Sensing Analyst",
    "GIS Specialist",
    "Geospatial Data Scientist",
  ],
  description:
    "I am a motivated and versatile Remote Sensing Scientist and Geomatics Engineer, passionate about learning and embracing new challenges. With a strong foundation in GIS, data science, machine learning, and deep learning, I am dedicated to delivering high-quality, impactful solutions. Guided by a positive attitude and a growth mindset, I strive to turn geospatial data into meaningful insights and contribute to innovative projects that make a difference.",
  github: "https://github.com/ayouboihi",
  resume:
    "https://drive.google.com/file/d/1vw49E4d2HjhZR9Lr5XdhILWDz6e28XWS/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/ayoub-oihi-0580a5229/",
  twitter: "https://x.com/AOihi99",
  insta: "https://www.instagram.com/ayouboihi99/",
  facebook: "https://github.com/ayouboihi",
  Youtube: "https://www.youtube.com/@SpatialDataAcademy",
};

export const skills = [
  {
    title: "Data science",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Statistics & Mathematics",
        image:
          "https://img.favpng.com/5/3/21/graphic-icon-basic-icons-icon-business-statistics-graphic-icon-RwNRUJfx.jpg",
      },
      {
        name: "Machine Learning",
        image:
          "https://cdn-icons-png.flaticon.com/512/8637/8637099.png",
      },
      {
        name: "Deep Learning",
        image: "https://cdn-icons-png.flaticon.com/512/10321/10321818.png",
      },
      {
        name: "Data Visualization",
        image:
          "https://cdn-icons-png.flaticon.com/512/7891/7891628.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Data Analysis",
        image:
          "https://cdn-icons-png.flaticon.com/512/2474/2474209.png",
      },
      {
        name: "Matlab",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/2/21/Matlab_Logo.png/1200px-Matlab_Logo.png",
      },
      {
        name: "R",
        image:
          "https://www.fileeagle.com/data/2021/05/RStudio.png",
      },
      {
        name: "PostgreSQL",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Postgresql_elephant.svg/640px-Postgresql_elephant.svg.png",
      },
      {
        name: "Feature Engineering",
        image:
          "https://img.freepik.com/premium-vector/feature-engineering-icon-vector-image-can-be-used-data-science_120816-359334.jpg",
      },
      {
        name: "Exploratory Data Analysis",
        image:
          "https://cdn-icons-png.flaticon.com/512/8317/8317643.png",
      },
      {
        name: "Data Cleaning",
        image:
          "https://cdn-icons-png.flaticon.com/256/10179/10179118.png",
      },
      {
        name: "Model Evaluation & Validation",
        image:
          "https://cdn-icons-png.flaticon.com/256/1721/1721585.png",
      },
    ],
  },
  {
    title: "Remote Sensing",
    skills: [
      {
        name: "Satellite Image Processing",
        image: "https://cdn-icons-png.flaticon.com/512/10479/10479796.png",
      },
      {
        name: "Image Classification",
        image:
          "https://cdn-icons-png.flaticon.com/512/9831/9831312.png",
      },
      {
        name: "Change Detection Analysis",
        image: "https://cdn-icons-png.flaticon.com/256/17116/17116636.png",
      },
      {
        name: "Hyperspectral Data Analysis",
        image:
          "https://www.sfpt.fr/hyperspectral/wp-content/uploads/2013/10/principe_hyperspectral_fig2.jpg",
      },
      {
        name: "Multispectral Image Processing",
        image:
          "https://img.favpng.com/18/12/3/geographic-information-system-computer-icons-arcgis-map-geospatial-analysis-png-favpng-xyeRqQirhVTHhHkH1PFkPzgA3.jpg",
      },
      {
        name: "Time-Series Satellite Analysis",
        image: "https://cdn-icons-png.flaticon.com/256/14106/14106352.png",
      },
      {
        name: "Spectral Index Computation",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSzs6xYY1dIynK2TL1l71pr2HtjRsHyPuL3VA&s",
      },
      {
        name: "Cloud Masking Preparation",
        image: "https://cdn-icons-png.flaticon.com/512/7010/7010131.png",
      },
      {
        name: "Automated Data Downloading",
        image: "https://cdn-icons-png.flaticon.com/512/6008/6008101.png",
      },
    ],
  },
  {
    title: "Satellite Imagery Platforms",
    skills: [
      {
        name: "Google Earth Engine",
        image:
          "https://images.icon-icons.com/1508/PNG/512/googleearth-engine_104576.png",
      },
      {
        name: "USGS Earth Explorer",
        image:
          "https://the-public-domain-review.imgix.net/sources/USGS_logo_green.jpg?h=1200&auto=format,compress",
      },
      {
        name: "Copernicus Open Access Hub",
        image:
          "https://images.seeklogo.com/logo-png/50/1/copernicus-logo-png_seeklogo-501801.png",
      },
      {
        name: "NASA Earthdata",
        image:
          "https://i.pinimg.com/736x/9a/3f/68/9a3f6831ebee205f974bc6a934d74628.jpg",
      },
      {
        name: "Copernicus Climate Data Store",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdENvhJjYw-Hoe-7O6fEIJ5Ye5JNfn5EZYYdxHGuToI1EjulRzL9XpIEF3ActayFGA3ME&usqp=CAU",
      },
      {
        name: "AWS Open Data Registry",
        image:
          "https://cdn.asp.events/CLIENT_CloserSt_D86EA381_5056_B739_5482D50A1A831DDD/sites/cloud-expo-london-2025/media/libraries/testing/6.png/fit-in/500x500/filters:no_upscale()",
      },
      {   
        name: "Sentinel Hub (EO Browser, API)",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSTzy9_b6ZmAcEVg2uBzme05Htfh-QtMjSlJfFfhrfVNKrwU5uuj9VriczdQiJdlsbLzU4&usqp=CAU",
      },
      {    
        name: "NSIDC",  
        image:
          "https://seeklogo.com/images/N/national-snow-and-ice-data-center-logo-3C9C98AD1C-seeklogo.com.png",
      },
      {    
        name: "NOAA CLASS",  
        image:
          "https://www.noaa.gov/sites/default/files/2022-03/noaa_digital_logo-2022.png",
      },
      {    
        name: "NASA SEDAC",  
        image:
          "https://toppng.com/uploads/preview/nasa-logo-11536003920rmadv844kw.png",
      },
      {    
        name: "Field Data Collection",
        image:
          "https://cdn-icons-png.flaticon.com/512/2103/2103552.png",
      },
    ],
  },
  {
    title: "Software & Tools",
    skills: [
      {
        name: "Jupyter",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS15qWl9Cr-XF_tqmFnLyFeRYzwodhobGMVzH1taalam8bds_kaBNDPyVSKEqDVeGzRY44&usqp=CAU",
      },
      {
        name: "ArcGIS",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQzdznNRS5vzNXzDnkNK7ttKNDckNU9viVPYg&s",
      },
      {
        name: "QGIS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/9/91/QGIS_logo_new.svg",
      },
      {
        name: "ENVI",
        image:
          "https://www.nhtgs.net/wp-content/uploads/2021/03/ENVI_logo.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Google Colab",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTvyuHWMd6UOi4d_oVuHTBZsGvS7kG6TFK2yQ&s",
      },
      {
        name: "Geospatial APIs",
        image:
          "https://cdn-icons-png.flaticon.com/512/9307/9307632.png",
      },
      {
        name: "Canva",
        image:
          "https://static.vecteezy.com/system/resources/previews/032/329/173/non_2x/canva-icon-logo-symbol-free-png.png",
      },
      {
        name: "leica geosystems",
        image:
          "https://leveltech.in/assets/img/service/leica-lg.png",
      },
      {
        name: "Rasterio",
        image:
          "https://geog-510.gishub.org/_static/logo.png",
      },
      {
        name: "GDAL",
        image:
          "https://www.osgeo.org/wp-content/uploads/gdal-2.png",  
      },
      {
        name: "Geopandas",
        image:
          "https://geopandas.org/en/latest/_images/geopandas_icon_green.png",
      },
      {
        name: "Seaborn", 
        image:
          "https://cdn.worldvectorlogo.com/logos/seaborn-1.svg",
      },
      {
        name: "Matplotlib",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Matplotlib_icon.svg/1024px-Matplotlib_icon.svg.png",
      },
      {
        name: "Agisoft Metashape",
        image:
          "https://www.aerialclick.com/423-medium_default/agisoft-metashape-professional.jpg",
      },
      {
        name: "NumPy",
        image:
          "https://logosandtypes.com/wp-content/uploads/2024/02/NumPy.png",
      },
      {
        name: "Scikit-learn",
        image:
          "https://www.stickerpress.in/media/products/full/98cbcf5d60a444d79d09d57e124751dd.jpg",
      },
      {
        name: "TensorFlow",
        image:
          "https://images.seeklogo.com/logo-png/39/2/tensorflow-logo-png_seeklogo-394548.png",
      },
      {
        name: "XARRAY",
        image:
          "https://raw.githubusercontent.com/xarray-contrib/xarray.dev/main/public/Xarray-assets/Icon/Xarray_Icon_Final.png",
      },
    ],
  },
  {
    title: "Research & Analysis Themes",
    skills: [
      {
        name: "Hydrological Modeling",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpUd6TEmKPSnC3efqFar69upg0Odjg7cR7xA&s",
      },
      {
        name: "Hydrogeological Analysis",
        image:
          "https://cdn-icons-png.flaticon.com/512/8228/8228636.png",
      },
      {
        name: "Land Use / Land Cover Change (LULC)",
        image:
          "https://cdn-icons-png.flaticon.com/512/7447/7447256.png",
      },
      {
        name: "Watershed & River Basin Studies",
        image:
          "https://easy-peasy.ai/cdn-cgi/image/quality=80,format=auto,width=700/https://v3.fal.media/files/tiger/Jt7UG4N_PD2YYBqjQ8hi1_image.webp",
      },
      {
        name: "Groundwater Monitoring",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJGaR1zWSBHDSKXFaQ3MAP83Kh_ZQm6WoRPg&s",
      },
      {
        name: "Drought and Water Scarcity Analysis",
        image:
          "https://img.favpng.com/6/0/13/water-conservation-water-efficiency-water-scarcity-washing-png-favpng-2vdEX7feAbYAuCSfL65i0U6cK.jpg",
      },
    ],
  },
  {
    title: "Languages",
    skills: [
      {
        name: "Arabic (Native)",
        image:
          "https://cdn-icons-png.flaticon.com/512/197/197551.png",
      },
      {
        name: "German (Intermediate - B1)",
        image:
          "https://cdn-icons-png.flaticon.com/512/3909/3909219.png",
      },
      {
        name: "English (Intermediate - A2)",
        image:
          "https://cdn-icons-png.flaticon.com/512/197/197374.png",
      },
      {
        name: "French (Fluent - B2)",
        image:
          "https://cdn-icons-png.flaticon.com/512/197/197560.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsFQCZHYernuDQqHgRrE97cy76d-WI8BGaKg&s",
    role: "Geospatial Data Scientist - Groundwater Prediction Researcher - Hydroinformatics Analyst",
    company: "Center for Remote Sensing Application - Mohammed VI Polytechnic University.",
    date: "Feb 2023 - Aug 2023",
    desc: "I worked as a Researcher in Remote Sensing and Machine Learning, focusing on groundwater level prediction in the Oum Er Rbia watershed. My tasks included data collection (GEE, GRACE, satellite imagery), model development (ML & DL), and spatial analysis with GIS tools to support sustainable water resource planning.",
    skills: [
      "Hydrological Data Analysis",
      "Machine Learning & Deep Learning Modeling",
      "Data Preprocessing",
      "Satellite Data Collection using GEE",
      "Hyperparameter Tuning & Cross-validation",
      "Python Programming",
      "Spatial Data Analysis (GIS)",
      "Remote Sensing Application",
      "Data Visualization",
      "Scientific Reporting & Documentation",
    ],
    //doc: "https://drive.google.com/file/d/1qMBIwxQBLHgUN_CE-YUamnMLfQzYWcyU/view?usp=sharing",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRsFQCZHYernuDQqHgRrE97cy76d-WI8BGaKg&s",
    role: "Hydrological Data Analyst",
    company: "Center for Remote Sensing Application - Mohammed VI Polytechnic University.",
    date: "Aug 2022 - Oct 2022",
    desc: "I developed and applied machine learning models to predict groundwater storage changes by analyzing hydrological and satellite data. My work involved data collection, cleaning, feature engineering, model training, and validation to support accurate water resource management and decision-making.",
    skills: [
      "Hydrological Data Collection & Analysis",
      "Machine Learning for Environmental Modeling",
      "Google Colab Proficiency",
      "MATLAB Programming for Hydrology",
      "Satellite Remote Sensing Data Handling",
      "Data Cleaning & Preprocessing",
      "Data Visualization",
    ],
    //doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  },
  {
    id: 2,
    img: "https://pangrampangram.com/cdn/shop/articles/442269ac56eddaecd3fa3dd752c38870.jpg?v=1631828825",
    role: "Data Collection & Cleaning",
    company: "Upwork (Freelance)",
    date: "Jan 2024 - Apr 2024",
    desc: "Collected and cleaned hydrological datasets from multiple sources using APIs and remote sensing platforms. Automated data acquisition processes using tools like Google Earth Engine and open-source APIs to ensure efficient and accurate data retrieval. Prepared structured datasets for environmental analysis and modeling tasks.",
    skills: [
      "Google Earth Engine",
      "Hydrological Data Processing",
      "API Integration for Data Access",
      "Remote Sensing Data Handling",
      "Data Cleaning & Quality Control",
      "Python",
      "JavaScript",
      "CSV, NetCDF, GeoTIFF Handling",
      "Metadata & Documentation",
      "ArcGIS",
    ],
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYB_KFyDGkLvR_4fMLXyFqOTISOz7_Vv8WQw&s",
    role: "GIS Mapping & Cartography",
    company: "Fiverr (Freelance)",
    date: "Feb 2024 - Apr 2024",
    desc: "Created professional and customized maps for clients using GIS software such as ArcGIS Pro and ENVI. Handled raster and vector data formats including GeoTIFF and shapefiles to produce accurate land use, topographic, and environmental maps. Provided services including spatial analysis, layout design, and high-resolution exports tailored for reports, research, and presentations.",
    //doc: "https://media.licdn.com/dms/image/D4D22AQGzSpgFaR4hsQ/feedshare-shrink_800/0/1684079632872?e=1687996800&v=beta&t=i0xWn_k32Oj9SxKfc6rARSbOghXD9Ge6WyEb2p2vvrc",
    skills: [
      "ArcGIS Pro",
      "ENVI",
      "QGIS",
      "GeoTIFF, Shapefile, KML",
      "Data Cleaning & Quality Control",
      "Coordinate systems and projections",
      "Canva",
      "Cartographic Design",
      "Metadata & Documentation",
      "Remote Sensing Image Processing",
    ],
  },
  {
    id: 4,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbjM2rdCXem78brlNByH6Q3b9NrF2rzOI8cA&s",
    role: "Topography & Work Monitoring",
    company: "CAPEP - Sebou Bouregreg Hydraulic Basin Interconnection",
    date: "Jul 2021 - Dec 2021",
    desc: "I am a dedicated intern with hands-on experience in topography and work monitoring, contributing to the large-scale Sebou-Bouregreg Hydraulic Basin Interconnection Project. My role involves precise topographic surveys, quality control, and close collaboration with technical teams to ensure the successful implementation of critical water infrastructure. Through this project, I have developed a strong understanding of water resource management challenges and solutions in Morocco, particularly in addressing drought and regional water shortages. I am passionate about applying my skills to support sustainable infrastructure development and effective environmental management.",
    skills: [
      "Topographic Surveying",
      "Construction Site Monitoring",
      "Quality Control & Assurance",
      "Hydraulic Infrastructure Knowledge",
      "Data Collection & Reporting",
    ],
  },
  {
    id: 5,
    img: "https://images.seeklogo.com/logo-png/31/1/universite-sultan-moulay-slimane-beni-mella-logo-png_seeklogo-315877.png",
    role: "Positioning Systems Intern",
    company: "Laboratory of Remote Sensing and GIS Applied to Geosciences and the Environment",
    date: "Apr 2021 - Jun 2021",
    desc: "I am an enthusiastic intern specializing in geospatial data collection and GNSS positioning systems. During my internship at Data4Earth, University Sultan Moulay Slimane, I gained hands-on experience creating polygonal canvases using various GNSS technologies. This opportunity enhanced my skills in precise spatial data acquisition, field surveying, and geospatial analysis, enabling me to contribute effectively to mapping and environmental monitoring projects. I am passionate about applying geomatics techniques to solve real-world spatial challenges and support sustainable land management.",
    skills: [
      "GNSS",
      "GPS",
      "Post-Processing Kinematic (PPK)",
      "Leica Software (e.g., Leica Geo Office)",
      "Real-Time Kinematic (RTK)",
      "GIS Mapping Techniques",
      "Stop-and-Go Surveying",
      "Coordinate Systems and Projections",
    ],
    //doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  },
];

export const education = [
  {
    id: 0,
    img: "https://no9tapress.com/wp-content/uploads/2024/03/logo-ministere_-educataion.jpg",
    school: "Annasr High School, Public School - Bradia",
    date: "Sep 2016 - Jun 2017",
    grade: "***",
    desc: "This academic track focused on deepening knowledge in physics, chemistry, and mathematics. It provided a strong scientific foundation through both theoretical learning and practical laboratory work. The curriculum emphasized problem-solving, critical thinking, and analytical skills, preparing students for university studies in scientific and technical fields such as engineering, medicine, and applied sciences.",
    degree: "Baccalaureate in Physical and Chemical Sciences",
  },
  {
    id: 1,
    img: "https://images.seeklogo.com/logo-png/31/1/universite-sultan-moulay-slimane-beni-mella-logo-png_seeklogo-315877.png",
    school: "Faculty of sciences and techniques - Sultan Moulay Slimane University - Beni Mellal",
    date: "Sep 2017 - Jun 2020",
    grade: "***",
    desc: "I am a dedicated and motivated graduate of the multidisciplinary MIPC program at Sultan Moulay Slimane University, where I developed strong skills in mathematics, computer science, physics, and chemistry. Throughout my studies, I gained solid theoretical knowledge and hands-on experience, which enhanced my analytical thinking, problem-solving abilities, and technical expertise. This diverse scientific background equips me to tackle complex challenges and pursue a career in research, technology, or applied sciences with confidence and adaptability.",
    degree: "University degree in Mathematics, informatics, physics, and chemistry (MIPC).",
  },
  {
    id: 2,
    img: "https://images.seeklogo.com/logo-png/31/1/universite-sultan-moulay-slimane-beni-mella-logo-png_seeklogo-315877.png",
    school: "Faculty of sciences and techniques - Sultan Moulay Slimane University - Beni Mellal",
    date: "Sep 2020 - Jun 2021",
    grade: "***",
    desc: "I am a motivated graduate in Geomatics and Territorial Management from Sultan Moulay Slimane University, with comprehensive training in spatial data acquisition, processing, and analysis. My studies covered advanced topics such as Geographic Information Systems (GIS), remote sensing, cartography, land use planning, and environmental management. I gained practical experience in handling geospatial technologies and tools to collect, visualize, and interpret geographic information. Passionate about leveraging spatial data for sustainable territorial development, I am committed to applying innovative solutions to support natural resource management, urban planning, and environmental conservation. My interdisciplinary background equips me to collaborate effectively with stakeholders and contribute meaningfully to projects aimed at improving land use and regional development.",
    degree: "Bachelor's degree in geomatics and territorial management (GAT).",
  },
  {
    id: 3,
    img: "https://images.seeklogo.com/logo-png/31/1/universite-sultan-moulay-slimane-beni-mella-logo-png_seeklogo-315877.png",
    school: "Faculty of sciences and techniques - Sultan Moulay Slimane University - Beni Mellal",
    date: "Sep 2021 - Jun 2023",
    grade: "***",
    desc: "The Master’s degree in Environmental Geomatics at Sultan Moulay Slimane University provides advanced scientific and technical training for future geomatics engineers specializing in environmental applications. This multidisciplinary program combines Geographic Information Systems (GIS), remote sensing, spatial analysis, and environmental data modeling. It prepares engineers to collect, process, and interpret geospatial data to address environmental challenges such as land use planning, natural resource management, and climate-related risks. Emphasizing both theoretical knowledge and practical skills, the program equips students with the tools needed to design innovative, data-driven solutions for sustainable development and territorial management.",
    degree: "Master's degree in Environmental Geomatics (GE).",
  },
  {
    id: 3,
    img: "https://images.seeklogo.com/logo-png/31/1/universite-sultan-moulay-slimane-beni-mella-logo-png_seeklogo-315877.png",
    school: "Faculty of sciences and techniques - Sultan Moulay Slimane University - Beni Mellal",
    date: "Sep 2023 - Current ...",
    grade: "***",
    desc: "My PhD research focuses on monitoring groundwater storage variations using satellite-based geospatial data (e.g., GRACE, GRACE-FO) alongside advanced data-driven modeling techniques, including machine learning, deep learning, and hydrological models. The objective is to analyze spatiotemporal changes in groundwater resources within a major Moroccan river basin by integrating remote sensing, GIS, machine learning, deep learning, and hydrological modeling approaches. This interdisciplinary work aims to support sustainable water management and improve decision-making under climate and hydrological stress.",
    degree: "PhD Student in Remote Sensing and Hydrological Modeling",
  },
];

export const projects = [
  {
    id: 9,
    title: "Topographical, hydrological, hypsometric and morphological characterization of the Oum Er-Rbia watershed using GIS",
    date: "Jun 2023 - Jul 2023",
    description:
      "This project focuses on the topographical, hydrological, hypsometric, and morphological characterization of the Oum Er-Rbia watershed using Geographic Information Systems (GIS) techniques. It involves the use of Digital Elevation Models (DEMs) and geospatial datasets to analyze elevation, slope, drainage patterns, and landform features. Key processes include watershed delineation, hypsometric curve generation, stream network extraction, and morphometric parameter calculation. The goal is to assess the watershed's geomorphological behavior and hydrological response, supporting better water resource management and environmental planning.",
    image: HeroImg1,
    tags: [
      "Satellite Imagery",
      "DEM Data",
      "Raster Processing",
      "Spatial Analysis",
      "Map Visualization",
      "Geo-referencing",
      "Vector Data",
      "ENVI Software",
      "Python Scripting",
      "Spatial Statistics",
      "ArcGIS Pro",
    ],
    category: "web app",
    //github: "https://github.com/ayouboihi",
    //webapp: "https://trackify.duckdns.org",
  },
  {
    id: 0,
    title: "Hyperspectral Preprocessing and Analysis for Mineralogical Mapping, Example of using AVIRIS in ENVI and Python",
    date: "Apr 2023 - May 2023",
    description:
      "This project involves hyperspectral data preprocessing and analysis for mineralogical mapping, using the AVIRIS (Airborne Visible/Infrared Imaging Spectrometer) dataset. The objective is to extract and identify mineralogical features based on their spectral signatures. The workflow includes radiometric and atmospheric correction, spectral subset selection, noise reduction, and endmember extraction. The analysis is performed using both ENVI software (for visual and spectral processing) and Python scripting (for automation and advanced analysis). This project demonstrates how hyperspectral imaging, combined with modern tools, can enhance geological interpretation and support mineral exploration.",
    image: HeroImg2,
    tags: ["Hyperspectral Analysis", "Mineralogical Mapping", "ENVI Software", "AVIRIS Data Processing", "Python for Remote Sensing"],
    category: "web app",
    //github: "https://github.com/rishavchanda/Podstream",
    //webapp: "https://podstream.netlify.app/",
    member: [
      {
        name: "Ayoub OIHI",
        img: HeroImg,
        linkedin: "https://www.linkedin.com/in/ayoub-oihi-0580a5229/",
        github: "https://github.com/ayouboihi",
      },
      {
        name: "Yahya Koura",
        img: HeroImg3,
        linkedin: "https://www.linkedin.com/in/yahya-koura-a84438232/",
        //github: "https://github.com/upasana0710",
      },
    ],
  },
  {
    id: 1,
    title: "Analysis of MODIS satellite images to monitor vegetation response to climatic conditions.",
    date: "Oct 2022 - Present",
    description:
      "This project focuses on the analysis of MODIS (Moderate Resolution Imaging Spectroradiometer) satellite imagery to monitor vegetation dynamics in response to climatic variations over time. Using time-series data, key vegetation indices such as NDVI (Normalized Difference Vegetation Index) are extracted and analyzed to detect seasonal and interannual trends. The project integrates climatic datasets (e.g., temperature, precipitation) with satellite-derived vegetation indicators to assess the impact of climate on vegetation health and distribution. Tools such as Google Earth Engine (GEE) and Python are used for data processing, visualization, and statistical analysis.",
    image: HeroImg4,
    tags: [
      "MODIS Imagery Analysis",
      "Vegetation Indices (NDVI, EVI)",
      "Time-Series Analysis",
      "GEE",
      "Python",
      "Geospatial Data Processing",
    ],
    category: "web app",
    //github: "https://github.com/ayouboihi",
    //webapp: "https://vexa-app.netlify.app/",
  },
  /*{
    id: 2,
    title: "Brain Tumor Detection",
    date: "Jan 2023 - Mar 2023",
    description:
      "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
    image:
      "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
    webapp: "https://brain-tumor.netlify.app/",
    member: [
      {
        name: "Rishav Chanda",
        img: "https://avatars.githubusercontent.com/u/64485885?v=4",
        linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
        github: "https://github.com/rishavchanda/",
      },
      {
        name: "Upasana Chaudhuri",
        img: "https://avatars.githubusercontent.com/u/100614635?v=4",
        linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
        github: "https://github.com/upasana0710",
      },
    ],
  },*/
  /*{
    id: 3,
    title: "Buckoid",
    date: "Dec 2021 - Apr 2022",
    description:
      "App Is Currently In Playstore 100+ Downloads. This Project proposes an “Expense Tracking App”. Keep track of your personal expenses and compare them to your monthly income with the budget planner. It has Google Drive Cloud API for Backup of User Room Database. Made with Kotlin in MVVM Architecture & Live Data.",
    image:
      "https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
    tags: ["Kotlin", "MVVM", "Room Database", "Google Drive Cloud API"],
    category: "android app",
    github: "https://github.com/rishavchanda/Buckoid-Android-App",
    webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  },
  {
    id: 10,
    title: "Job Finding App",
    date: "Jun 2023 - Jul 2023",
    description:
      "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
    image:
      "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
    tags: ["React Native", "JavaScript", "Axios"],
    category: "android app",
    github: "https://github.com/rishavchanda/Job-finder-App",
    webapp: "https://github.com/rishavchanda/Job-finder-App",
  },*/
  /*{
    id: 4,
    title: "Whatsapp Clone",
    date: "Jul 2021",
    description:
      "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
    tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Whatsapp-Clone-React-Js",
    webapp: "https://whatsapp-clone-rishav.web.app",
  },*/
  /*{
    id: 5,
    title: "Todo Web App",
    date: "Jun 2021",
    description:
      " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    image:
      "https://camo.githubusercontent.com/a328255ad96f861f57d25096d28018ab2656c689a1456b0d145764009bed2d1a/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f74253230283938292e706e673f616c743d6d6564696126746f6b656e3d33643335646366322d626666322d343730382d393031632d343232383866383332386633",
    tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Todo-Web-App",
    webapp: "https://rishav-react-todo.netlify.app/",
  },*/
  /*{
    id: 6,
    title: "Breaking Bad",
    date: "Jun 2021",
    description:
      "A simple react app that shows the characters of the famous TV series Breaking Bad. It uses the Breaking Bad API to fetch the data. It also has a search bar to search for a particular character.",
    image:
      "https://camo.githubusercontent.com/cd07010cbeb90cb1b43a5d6162784326aef02210ef7d41a0f9ae043b3e392378/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f746f646f2d6170702d63386331392e61707073706f742e636f6d2f6f2f53637265656e73686f7425323028313534292e706e673f616c743d6d6564696126746f6b656e3d65613439383630632d303435362d343333342d616435372d336239346663303333363263",
    tags: ["React Js", "API", "Axios", "Node JS"],
    category: "web app",
    github: "https://github.com/rishavchanda/Breaking-Bad",
    webapp: "https://breaking-bad-webapp.netlify.app",
  },*/
  {
    id: 7,
    title: "GIS-Based Site Selection for a Controlled Landfill: A Case Study in Beni Mellal-Khénifra",
    date: "Dec 2023 - Jan 2024",
    description:
      "This project focuses on the use of Geographic Information Systems (GIS) and Multi-Criteria Decision Analysis (MCDA) to identify suitable locations for a controlled landfill in the Beni Mellal-Khénifra region. By utilizing GIS tools such as ArcGIS, QGIS, and spatial analysis techniques (e.g., buffering, overlay analysis, and reclassification), the study integrates environmental, socio-economic, and technical criteria—such as land use, slope, hydrology, proximity to urban areas, and protected zones. These geospatial tools enabled the development of a suitability map through a weighted overlay model, helping to support sustainable decision-making in environmental planning. The project offers a reliable and data-driven solution for waste management site selection, ensuring minimal ecological impact and alignment with national environmental policies.",
    image: HeroImg6,
    tags: ["ArcGIS", "QGIS", "Multi-Criteria Decision Analysis", "Geospatial Data", "Environmental Planning", "Landfill Site Selection"],
    category: "android app",
    //github: "https://github.com/rishavchanda/Quiz-Earn",
    //webapp: "https://github.com/rishavchanda/Quiz-Earn",
  },
  {
    id: 8,
    title: "Groundwater storage prediction using machine learning and deep learning tools: case study of Oum Er Rbia watershed",
    date: "Jun 2021",
    description:
      "This study focuses on the prediction of groundwater storage variations within the Oum Er Rbia watershed using advanced machine learning (ML) and deep learning (DL) techniques. By integrating satellite-based datasets (such as GRACE/GRACE-FO) with hydrological and climatic variables (precipitation, temperature, evapotranspiration, etc.), the research aims to develop data-driven models capable of accurately forecasting groundwater trends in the region. Several algorithms—such as Random Forest (RF), Support Vector Regression (SVR), and Long Short-Term Memory (LSTM) neural networks—are tested and compared to assess their predictive performance. The outcomes of this work support sustainable water resource management by providing insight into future groundwater availability under changing environmental conditions.",
    image: HeroImg5,
    tags: ["Python", "Keras", "TensorFlow", "LSTM", "GRACE", "TRMM", "MODIS", "SVM", "GRU", "MLP", "ERA5"],
    category: "machine learning",
    //github: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
    //webapp: "https://github.com/rishavchanda/Face-Recodnition-AI-with-Python",
  },
];

/*export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];*/